export const propertyKeys = [
  'id',
  'name',
  'regions',
  'jobType',
  'creator',
  'assignedTo',
  'createdTimestamp',
  'numberOfDesigns',
  'openedBy',
  'organizationOwnedBy',
  'jobStatus',
  'jobPriority',
  'sharedWithOrganizations',
  'billingLocation',
] as const;

export type PropertyKey = (typeof propertyKeys)[number];

export const displayNames: { [K in PropertyKey]: string } = {
  id: 'ID',
  name: 'Name',
  regions: 'Regions',
  jobType: 'Job Type',
  creator: 'Created By',
  assignedTo: 'Assigned To',
  createdTimestamp: 'Created At',
  numberOfDesigns: '# Designs',
  openedBy: 'Opened By',
  organizationOwnedBy: 'Customer',
  jobStatus: 'Status',
  jobPriority: 'Priority',
  sharedWithOrganizations: 'Shared With',
  billingLocation: 'Location',
};

export const lockedColumns: readonly PropertyKey[] = ['id', 'name'];
export const unlockedColumns = propertyKeys.filter((propertyKey) => !lockedColumns.includes(propertyKey));
